<template>
  <el-input
    v-bind="$attrs"
    v-on="$listeners"
    :type="show ? 'text' : 'password'">
      <i class="el-icon-view" slot="suffix" @click="trigger"></i>
    </el-input>
</template>
<script>
export default {
  name: 'PswInput',
  data () {
    return {
      show: false
    }
  },
  methods: {
    trigger () {
      this.show = !this.show
    }
  }
}
</script>
